import { Actions as AppActions } from '../actions/app';
import { Actions as StreamApiActions, CommandType } from '../actions/streamApi';
import { Dispatch } from 'redux';
import { getStompConnectionManager } from '../services/stomp/connectionManager';

/**
 * Redux adapter for the STOMP session. It holds no state: every decision about
 * connections, subscriptions and queues lives in `StompConnectionManager`.
 */
const streamStompMiddleware = (store: { getState; dispatch: Dispatch }) => (
  next: (action: any) => any
) => (action: any) => {
  // Reducers see the action before the socket acts on it, so anything the
  // manager reads back out of the store is already up to date.
  const result = next(action);

  switch (action.type) {
    case AppActions.ACCESS_TOKEN_UPDATED:
    case AppActions.RESET_SOCKET_CONNECTION:
      getStompConnectionManager().connect(store, action.accessToken, {
        force: action.type === AppActions.RESET_SOCKET_CONNECTION,
      });
      break;

    case StreamApiActions.SEND_MESSAGE: {
      const data = action.data;
      if (!data || !data.type) {
        break;
      }
      const manager = getStompConnectionManager();
      if (data.type === CommandType.SUBSCRIBE) {
        if (data.channel) manager.subscribe(store, data);
      } else if (data.type === CommandType.UNSUBSCRIBE) {
        if (data.channel) manager.unsubscribe(store, data);
      } else if (data.type.startsWith('ENQUEUE_')) {
        manager.publishEnqueue(store, data.type as CommandType, data);
      }
      break;
    }

    default:
      break;
  }

  return result;
};

export const cleanupStompMiddleware = () => {
  getStompConnectionManager().disconnect();
};

export default streamStompMiddleware;
